import RichTextEditor from '../../RichTextEditor.jsx';
import React, { useEffect } from 'react';
import TextInput from '../../TextInput';
import TextArea from '../../TextArea.jsx';

const EditAgreeToTermsForm = ({ settings, setSettings }) => {
    useEffect(() => {
        // Default 'required' to true
        console.log('settings = ', settings);
        if (typeof settings?.required === 'undefined') {
            setSettings({ ...settings, required: true });
        }
    }, []);

    return (
        <div>
            <div className="input-label mt-4">Description</div>
            <RichTextEditor
                initialValue={settings?.description || ''}
                onChange={value =>
                    setSettings({ ...settings, description: value })
                }
            />

            <div className="panel-label mt-4">Link to Terms</div>
            <div className="panel p-4">
                <TextInput
                    label="Terms Website Address"
                    inputClassName="w-full"
                    placeholder="https://my-website.com/terms"
                    value={settings?.url || ''}
                    onChange={value => setSettings({ ...settings, url: value })}
                />

                <TextInput
                    label="Terms Link Label"
                    inputClassName="w-full"
                    className="mt-4"
                    placeholder="View Terms"
                    value={settings?.urlLabel || ''}
                    onChange={value =>
                        setSettings({ ...settings, urlLabel: value })
                    }
                />
            </div>

            <TextInput
                className="mt-4"
                label="Agree Text"
                placeholder="I agree"
                value={settings?.agreeLabel || ''}
                onChange={value =>
                    setSettings({ ...settings, agreeLabel: value })
                }
            />
        </div>
    );
};

export default EditAgreeToTermsForm;
